<template>
    <MeetingDetailsBlock
        iconName="user-tie"
        title="Host"
    >
        <div class="truncate">
            {{ host.getFullName() }}
        </div>
    </MeetingDetailsBlock>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import MeetingDetailsBlock from '@/App/Booking/Meeting/Component/MeetingDetailsBlock.vue'
    import User from '@/App/User/Entity/User'

    const props = defineProps({
        host: {
            type: Object as PropType<User>,
            required: true,
        },
    })
</script>
